var KeyboardEventKey;

(function (KeyboardEventKey) {
  KeyboardEventKey["ESC"] = "Escape";
  KeyboardEventKey["TAB"] = "Tab";
  KeyboardEventKey["ENTER"] = "Enter";
  KeyboardEventKey["UP_ARROW"] = "ArrowUp";
  KeyboardEventKey["DOWN_ARROW"] = "ArrowDown";
  KeyboardEventKey["LEFT_ARROW"] = "ArrowLeft";
  KeyboardEventKey["RIGHT_ARROW"] = "ArrowRight";
  KeyboardEventKey["HOME"] = "Home";
  KeyboardEventKey["END"] = "End";
  KeyboardEventKey["PAGE_UP"] = "PageUp";
  KeyboardEventKey["PAGE_DOWN"] = "PageDown";
  KeyboardEventKey["BACKSPACE"] = "Backspace";
})(KeyboardEventKey || (KeyboardEventKey = {}));

export { KeyboardEventKey };
